export const GET_LIST_DUNOCHOVAY = "GET_LIST_DUNOCHOVAY";
export const GET_LIST_DUNOCHOVAY_SUCCESS = "GET_LIST_DUNOCHOVAY_SUCCESS";
export const GET_LIST_DUNOCHOVAY_FAILURE = "GET_LIST_DUNOCHOVAY_FAILURE";

export const UPDATE_SEARCHTDATA_DUNOCHOVAY = "UPDATE_SEARCHTDATA_DUNOCHOVAY";
